import { NavLink, Route, Routes, BrowserRouter, Outle, Navigate, HashRouter } from "react-router-dom";
import DevicesScreen from "./App/Phone/main"
import FeekbackPage from "./App/Phone/Feekback"
import TimeLapseShoot from "./App/Phone/TimeLapseShoot";
import ShootPanoramic from "./App/Phone/ShootPanoramic";
import TrackVideo from "./App/Phone/TrackVideo";
import AutoRotate from "./App/Phone/AutoRotate";
import LevelingInspection from "./App/Phone/LevelingInspection";

export default function AppFame(props) {
    return (
        <div
            style={{ backgroundColor: "#EFF0F4" }}
            class="container-full mx-auto h-full" >
            <Routes>
                <Route path='/' element={<Navigate to="/DeviceInfo/SCORP/ch" replace={true} />} />
                <Route path="/Feekback/:device/:language" element={<FeekbackPage /> } />
                <Route path="/DeviceInfo/:device/:language" element={<DevicesScreen />} /> 
                <Route path="/TimeLapseShoot/:language?" element={<TimeLapseShoot />} /> 
                <Route path="/ShootPanoramic/:language?" element={<ShootPanoramic/>}/>
                <Route path="/TrackVideo/:language?" element={<TrackVideo/>}/>
                <Route path="/AutoRotate/:language?" element={<AutoRotate/>}/>
                <Route path="/LevelingInspection/:language?" element={<LevelingInspection/>}/>
            </Routes>
        </div>
    )
}